import React, { useEffect, useState, useRef } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store/reducers/state';
import { useVideosActions, VideosActions } from 'src/store/videos/actions';
import { SelectModel } from 'src/models/videosModel';
import Loader from 'src/components/loader';
import Select from 'react-select';
import { customFilterOption } from 'src/components/utilities/utils';
import { useParams } from 'react-router-dom';
import { MemberListModel } from 'src/models/monetizationModel';
import EditCredits from './EditCredits';
interface IProps {
  videoId: string;
  isCreditActiveTab: boolean;
}
const CeCredit: React.FC<IProps> = ({ videoId, isCreditActiveTab }) => {
  const dispatch = useDispatch();
  const videoActions = useVideosActions(dispatch);
  const [jurisdictionEnabled, setJurisdictionEnabled] = useState<any>(false);
  const [finalMemberList, setFinalMemberList] = useState<SelectModel[]>();
  const { id } = useParams<string>();
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset
  } = useForm();

  const {
    creditJurisdictions,
    creditTypes,
    creditAllocation,
    isCreditAllocationAdded,
    isCreditAllocationDeleted,
    memberListAccess,
    memberList,
    isGetMemberAccessLoading,
    creditExclusion,
    isCreditExclusionAdded,
    isCreditExclusionDeleted
  } = useSelector((state: RootState) => {
    return {
      creditJurisdictions: state.videos.creditJurisdictions,
      creditTypes: state.videos.creditTypes,
      creditAllocation: state.videos.creditAllocation,
      isCreditAllocationAdded: state.videos.isCreditAllocationAdded,
      isCreditAllocationDeleted: state.videos.isCreditAllocationDeleted,
      memberListAccess: state.videos.memberListAccess,
      memberList: state.users.memberList,
      isGetMemberAccessLoading: state.videos.isGetMemberAccessLoading,
      creditExclusion: state.videos.creditExclusion,
      isCreditExclusionAdded: state.videos.isCreditExclusionAdded,
      isCreditExclusionDeleted: state.videos.isCreditExclusionDeleted
    };
  });
  const {
    handleSubmit: handleSubmit2,
    setValue: setValue2,
    formState: { errors: errors2 },
    control: control2
  } = useForm();
  const onSubmit = (data: any) => {
    if (id) {
      const payloadData = {
        creditTypeId: data?.creditType?.value,
        creditJurisdictionsId: data?.creditJurisdictions?.value,
        creditValue: data.value,
        referenceId: data.referenceId,
        videoId: id
      };
      videoActions.addCreditAllocationsRequestRequest(payloadData);
    }
  };
  const handleDeleteClick = (id: string) => {
    videoActions.deleteCreditAllocationsRequestRequest(id);
  };
  const handleEditClick = (data: string) => {
    id && videoActions.getSingleCreditAllocationsRequest({ videoId: id, id: data });
  };
  useEffect(() => {
    if (isCreditAllocationAdded || isCreditAllocationDeleted) {
      id && videoActions.getCreditAllocationsRequestRequest(id);
    }
  }, [isCreditAllocationAdded, isCreditAllocationDeleted]);
  useEffect(() => {
    if (isCreditAllocationAdded) {
      reset({ creditJurisdictions: '', value: '', creditType: '' });
    }
  }, [isCreditAllocationAdded]);
  useEffect(() => {
    if (creditAllocation) {
      setJurisdictionEnabled(creditAllocation?.jurisdictionEnabled);
    }
  }, [creditAllocation]);
  const handleUpdateEnableJurisdiction = (value: boolean) => {
    setJurisdictionEnabled((jurisdictionEnabled: any) => !jurisdictionEnabled);
    if (id) {
      videoActions.enableJurisdictionsRequestRequest({ id, value });
    }
  };

  const handleMemberListAccessSubmit = (data: any) => {
    const memberId = data.memberList.value;
    const finalData = { memberListId: memberId, videoId };
    videoActions.addCreditExclusionRequest(finalData);
    setValue2('memberList', '');
  };

  useEffect(() => {
    if (memberList && memberList.length) {
      if (memberList && memberList.length && creditExclusion.length) {
        const finalFilteredData = memberList.filter(function (memberList: MemberListModel) {
          return !creditExclusion.find(function (memberListAccess: any) {
            return memberListAccess.id == memberList.id;
          });
        });
        const options = finalFilteredData.map((item: MemberListModel) => ({
          value: item.id,
          label: item.name
        }));
        setFinalMemberList(options);
      } else {
        const options = memberList.map((item: MemberListModel) => ({
          value: item.id,
          label: item.name
        }));
        setFinalMemberList(options);
      }
    }
  }, [memberList, creditExclusion]);

  useEffect(() => {
    if (isCreditExclusionAdded || isCreditExclusionDeleted) {
      id && videoActions.getCreditExclusionRequest(id);
    }
  }, [isCreditExclusionAdded, isCreditExclusionDeleted]);

  const detachCreditExclusion = (memberId: string) => {
    if (id) {
      const payload = { videoId: id, memberID: memberId };
      videoActions.deleteCreditExclusionRequest(payload);
    }
  };

  const productInformation = localStorage.getItem('productInformation');
  const parsedProduct = productInformation && JSON.parse(productInformation);
  const isJurisdictionAllowed = parsedProduct?.jurisdictions !== false;
  return (
    <>
      {!isJurisdictionAllowed && (
        <>
          {isCreditActiveTab && (
            <div className=" inset-0 flex items-center justify-center bg-gray-200 bg-opacity-10">
              <div className="bg-white rounded-lg shadow-lg p-6 w-[360px] text-center relative">
                <h2 className="text-gray-900 font-semibold text-lg mb-2">
                  This feature isn’t included in your current plan.
                </h2>
                <p className="text-gray-600 text-sm mb-5">
                  Contact Sales to upgrade your plan and unlock access.
                </p>
                <button
                  className="bg-purple-700 hover:bg-purple-800 text-white font-semibold px-5 py-2 rounded-md"
                  onClick={() => {
                    window.open('https://support.webcastcloud.com/hc/en-us/requests/new', '_blank');
                  }}>
                  Contact Sales
                </button>
              </div>
            </div>
          )}
        </>
      )}

      <div
        className={`tab-pane fade ${
          !isJurisdictionAllowed ? 'opacity-40 pointer-events-none' : ''
        }`}
        id="tabs-cecreditView"
        role="tabpanel"
        aria-labelledby="tabs-access-view">
        <div className="p-5 pr-20">
          <div className="mb-8">
            <label className="font-semibold">Enable Jurisdiction Credits</label>
            <div className="flex">
              <p className="my-4">
                Credits achieved as dependant on user CE preferences and the credits available for
                each region/jurisdiction.
              </p>
              <div className="flex items-center ml-5">
                <div className="form-check form-switch pl-0 flex justify-between items-center mb-2">
                  <div className="relative">
                    <input
                      className="form-check-input switch-btn"
                      type="checkbox"
                      role="switch"
                      id="jurisdictionEnabled"
                      checked={jurisdictionEnabled}
                      onChange={(e) => handleUpdateEnableJurisdiction(e.target.checked)}
                    />
                    <i className="fas fa-check checkbox-tick hidden"></i>
                    <i className="fas fa-times checkbox-cross"></i>
                  </div>
                </div>
              </div>
            </div>
            <form onSubmit={handleSubmit(onSubmit)} className="mb-5 flex flex-wrap gap-4">
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 flex-grow">
                <div className="form-group">
                  <label className="block text-sm font-medium mb-1">Credit Type</label>
                  {creditTypes && (
                    <Controller
                      render={({ field: { onChange, value }, fieldState: { error } }) => (
                        <Select
                          filterOption={customFilterOption}
                          options={creditTypes.map((item) => ({
                            value: item.id,
                            label: item.type
                          }))}
                          value={value}
                          id="creditType"
                          className="w-full"
                          onChange={(val) => onChange(val)}
                          isLoading={!creditTypes.length}
                        />
                      )}
                      name="creditType"
                      control={control}
                      rules={{ required: true }}
                    />
                  )}
                  {errors.creditType?.type === 'required' && (
                    <span className="text-red-500 text-xs">Required Field</span>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1">Value</label>
                  <input
                    className="input-style w-full"
                    type="text"
                    id="value"
                    {...register('value')}
                  />
                </div>

                <div className="form-group">
                  <label className="block text-sm font-medium mb-1">Jurisdiction</label>
                  {creditJurisdictions && (
                    <Controller
                      render={({ field: { onChange, value }, fieldState: { error } }) => (
                        <Select
                          filterOption={customFilterOption}
                          options={creditJurisdictions.map((item) => ({
                            value: item.id,
                            label: item.jurisdictionName
                          }))}
                          value={value}
                          id="creditJurisdictions"
                          className="w-full"
                          onChange={(val) => onChange(val)}
                          isLoading={!creditJurisdictions.length}
                        />
                      )}
                      name="creditJurisdictions"
                      control={control}
                      rules={{ required: false }}
                    />
                  )}
                  {errors.creditJurisdictions?.type === 'required' && (
                    <span className="text-red-500 text-xs">Required Field</span>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1">Reference ID</label>
                  <input
                    className="input-style w-full"
                    type="text"
                    id="referenceId"
                    {...register('referenceId')}
                  />
                </div>
              </div>
              <div className="w-full md:w-auto flex items-end">
                <button type="submit" className="btn-primary whitespace-nowrap borderonly-btn">
                  Add
                </button>
              </div>
            </form>

            <div className="overflow-x-auto-sm">
              <table className="table-auto w-full border">
                <thead className="text-xs font-semibold uppercase bg-gray-100">
                  <tr>
                    <th className="p-2">
                      <div className="font-semibold text-left">Credit Type</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-left">Value</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-left">Jurisdiction</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-left">Reference ID</div>
                    </th>
                    <th className="p-2">
                      <div className="text-left invisible">Action</div>
                    </th>
                  </tr>
                </thead>
                <tbody className="text-sm divide-y divide-gray-100">
                  {creditAllocation &&
                    creditAllocation?.videoCreditAllocations?.map((item: any) => {
                      return (
                        <tr key={item.id}>
                          <td className="p-2">{item.creditType}</td>
                          <td className="p-2">{item.creditValue}</td>
                          <td className="p-2">{item.jurisdiction}</td>
                          <td className="p-2">{item.referenceId}</td>
                          <td className="p-2">
                            <div className="dropdown relative">
                              <a
                                className="
                                        dropdown-toggle
                                        transition
                                        duration-150
                                        ease-in-out border h-8 w-8 flex items-center justify-center rounded-md"
                                href="#"
                                type="button"
                                id="ActionButton"
                                data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <i className="fas fa-ellipsis-v"></i>
                              </a>
                              <ul
                                className="dropdown-menu action-dropdown"
                                aria-labelledby="ActionButton">
                                <li
                                  data-bs-toggle="modal"
                                  data-bs-target="#EditCredits"
                                  onClick={() => handleEditClick(item.id)}>
                                  <span className="dropdown-item flex-items cursor-pointer">
                                    <i className="fas fa-edit w-6"></i>
                                    <span>Edit</span>
                                  </span>
                                </li>
                                <li onClick={() => handleDeleteClick(item.id)}>
                                  <span className="dropdown-item flex-items cursor-pointer text-red-500">
                                    <i className="fas fa-trash w-6"></i>
                                    <span>Delete</span>
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <EditCredits />
        <div className="p-5 pr-20">
          <label className="font-semibold">Credit Exclusion</label>
          <p className="my-4"></p>

          <form
            onSubmit={handleSubmit2(handleMemberListAccessSubmit)}
            className="mb-5 flex items-center">
            {memberList && (
              <Controller
                render={({ field: { onChange, onBlur, value, ref }, fieldState: { error } }) => (
                  <Select
                    filterOption={customFilterOption}
                    options={finalMemberList}
                    value={value}
                    id="memberList"
                    className="w-full"
                    onChange={(val) => onChange(val)}
                    isLoading={memberList.length ? false : true}
                  />
                )}
                name="memberList"
                control={control2}
                rules={{ required: true }}
              />
            )}
            {errors2.memberList?.type === 'required' && (
              <span className="text-red-500 text-xs flex item-center error">Required Field</span>
            )}
            <button
              type="submit"
              className="btn-primary w-auto whitespace-nowrap mt-0 ml-5 borderonly-btn">
              Add
            </button>
          </form>
          <div className="mt-5">
            <table className="table-bordered w-1/2">
              <thead>
                <tr>
                  <th>List Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {creditExclusion && creditExclusion.length ? (
                  creditExclusion.map((member) => {
                    return (
                      <tr key={member.id}>
                        <td>{member.name}</td>
                        <td
                          className="cursor-pointer"
                          onClick={() => detachCreditExclusion(member.id)}>
                          Detach
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td>No Data Found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default CeCredit;
